import { VendorBuyer } from "@urbanx/agx-ui-components";

export const normalizeAddress = (buyer: VendorBuyer): VendorBuyer => {
    if (!buyer?.individual?.address) return buyer;
    const addr = buyer.individual.address;
    if (addr.address && !addr.alternate) {
        return {
            ...buyer,
            individual: {
                ...buyer.individual,
                address: {
                    sameAddress: addr.sameAddress,
                    alternate: {
                        streetAddress: addr.address.streetAddress,
                        suburb: addr.address.suburb,
                        state: addr.address.state,
                        postalCode: addr.address.postalCode,
                        unitNumber: addr.address.unitNumber,
                        country: addr.address.country,
                    },
                },
            },
        };
    }
    return buyer;
};

export const normalizeBuyers = (value: any): VendorBuyer[] => {
    if (!value) return [];

    const arr = Array.isArray(value) ? value : [value];

    return arr.map((b) => normalizeAddress(b));
};

export const sortBuyers = (buyers: VendorBuyer[]): VendorBuyer[] => {
    return buyers
        .slice()
        .sort((a, b) => (a?.id || '').localeCompare(b?.id || ''))
}

// Helper to get buyer names as a string, separated by ' & ' for multiple buyers
export const getBuyerNames = (buyers: VendorBuyer[]): string => {
    if (!buyers || buyers.length === 0) return '';
    const getName = (buyer: VendorBuyer): string => {
        if (buyer.individual?.name) {
            const n = buyer.individual.name;
            return [n.firstName, n.lastName].filter(Boolean).join(' ') || n.preferredName || n.title || '';
        }
        if (buyer.deceasedEstate?.name) {
            const n = buyer.deceasedEstate.name;
            return [n.firstName, n.lastName].filter(Boolean).join(' ') || n.preferredName || n.title || '';
        }
        if (buyer.company?.companyName) {
            return buyer.company.companyName;
        }
        if (buyer.powerOfAttorney?.principalName) {
            const n = buyer.powerOfAttorney.principalName;
            return [n.firstName, n.lastName].filter(Boolean).join(' ') || n.preferredName || n.title || '';
        }
        return buyer.legalName || '';
    };
    const names = buyers.map(getName).filter(Boolean);
    return names.length === 1 ? names[0] : names.join(' & ');
};